import { render, staticRenderFns } from "./xieyiSG.vue?vue&type=template&id=6dbe6be7&scoped=true&"
import script from "./xieyiSG.vue?vue&type=script&lang=js&"
export * from "./xieyiSG.vue?vue&type=script&lang=js&"
import style0 from "./xieyiSG.vue?vue&type=style&index=0&id=6dbe6be7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbe6be7",
  null
  
)

export default component.exports